import router from '@/router'
import store from '@/store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { api } from '@/api/apiList'
import http from '@/lib/http'
import { pushLxAnalyticsPV } from '@/utils'

const dailyActiveCid = 'c_mobikeops_tub8cq9x' // 平台日活cid，用于统计合作商平台全部页面的PV

router.beforeEach((to, from, next) => {
  NProgress.start()
  // 关闭所有massage
  Message.closeAll()
  // UAC权限判断
  if (store.state.uacStatus) {
    // next()
    if (store.state.uacRouteNameList.includes(to.name)) {
      next()
    } else {
      Message({
        type: 'error',
        message: `无权限访问「${to.meta.title}」页面，请根据左侧菜单访问页面`,
        duration: -1,
      })
      NProgress.done()
    }
  } else {
    // 从UAC获取路由信息并更新
    http
      .get(api.getMenuTree)
      .then(res => {
        // 提取从UAC获取到的路由信息
        // 最深3级，暂未使用递归实现
        const menu = JSON.parse(res.data)
        const { menuFolderList = [] } = menu
        const uacRoutes = []
        menuFolderList.forEach(item => {
          if (item.childrenMenuList.length) {
            item.childrenMenuList.forEach(subItem => {
              if (subItem.childrenMenuList.length) {
                subItem.childrenMenuList.forEach(lastItem => uacRoutes.push(lastItem.nodeCode))
              } else {
                uacRoutes.push(subItem.nodeCode)
              }
            })
          } else {
            uacRoutes.push(item.nodeCode)
          }
        })
        // 默认给about权限(06.09调整，默认进home页面)
        uacRoutes.push('/home')
        store.commit('updateUacRouteNameList', uacRoutes)
        store.commit('updateUacStatus', true)
        router.replace({ name: to.name, query: to.query })
      })
      .catch(e => {
        Message({
          type: 'error',
          message: e.message || '获取用户权限信息失败，请重试',
          duration: -1,
        })
        NProgress.done()
        throw e
      })
    // 获取操作权限的
    if (!store.state.uacApiAuth.length) store.dispatch('getUacAuth')
  }
})

router.afterEach(() => {
  console.log('检测到路由变化，发送PV埋点')
  pushLxAnalyticsPV(dailyActiveCid, {
    pathname: window.location.pathname,
  })
  NProgress.done()
})
